// Created by snov on 28.06.2016.
//

// launch via cluster launcher
require('./cluster-launcher');

// or comment above and uncomment below for single process server
//require('./worker')('default');


// WEBPACK FOOTER //
// ./src/server/index.js